module.exports = __webpack_public_path__ + "img/resume-empty.3d825696.svg";